// extracted by mini-css-extract-plugin
export default {"tableWrapper":"dataTable_tableWrapper__ir71+","tableRow":"dataTable_tableRow__lGFVC","tableCellLow":"dataTable_tableCellLow__5UnxM"};